import { Link } from "react-router-dom";
import PageMeta from "@/components/PageMeta";
import BreadcrumbJsonLd from "@/components/BreadcrumbJsonLd";
import { useImportGuides } from "@/lib/importGuides";

const GROUPS = [
  { title: "Upload a file from your recipe or notes app", test: (g) => g.method === "file" },
  { title: "Paste web links", test: (g) => g.method === "url" },
  { title: "Browser bookmarks", test: (g) => g.method === "bookmarks" },
  { title: "Screenshots & photos", test: (g) => g.method === "screenshot" },
];

export default function ImportHelpHub() {
  const data = useImportGuides();
  return (
    <div className="max-w-4xl mx-auto px-4 py-12" data-testid="import-help-hub">
      <PageMeta title="How to import your recipes — step-by-step guides for every app"
                description="Clear step-by-step guides for importing recipes into RecipeFiler from Paprika, Mela, Recipe Keeper, Copy Me That, Notion, Evernote, Google Keep, Plan to Eat, browser bookmarks, web links and screenshots."
                canonical="https://recipefiler.com/help/import" />
      <BreadcrumbJsonLd items={[{ name: "Home", url: "https://recipefiler.com/" }, { name: "Import guides", url: "https://recipefiler.com/help/import" }]} />
      <p className="overline mb-2">Help</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-rf-ink leading-tight">Import your recipes, step by step</h1>
      <p className="mt-4 text-slate-600 max-w-2xl">Pick where your recipes live now. Each guide shows exactly how to get them out of that app and into RecipeFiler, so it works first time. Files up to 500MB, photos included.</p>
      {GROUPS.map((grp) => {
        const list = (data?.guides || []).filter(grp.test);
        if (!list.length) return null;
        return (
          <section key={grp.title} className="mt-10">
            <h2 className="text-base md:text-lg font-bold text-slate-800 mb-3">{grp.title}</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {list.map((g) => (
                <Link key={g.key} to={g.own_page || `/help/import/${g.key}`} data-testid={`import-help-link-${g.key}`}
                      className="rounded-xl border border-slate-200 bg-white px-4 py-3 hover:border-rf-orange hover:bg-amber-50 transition-colors">
                  <span className="font-semibold text-slate-800">{g.label}</span>
                  <span className="block text-xs text-slate-500 mt-0.5">{g.files}</span>
                </Link>
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
